//Local nav
export default function localNav() {
	const localNav = document.querySelectorAll(".property_localnav li a");
	if (localNav.length > 0) {
		localNav.forEach(element => {
			const navPath = element.attributes.href.value;
			const currentPath = window.location.pathname;
			if (navPath === currentPath) {
				element.classList.add("current");
			}
		})
	}
}